import { jsx as _jsx } from "react/jsx-runtime";
import DashboardWorkspace from 'components/DashboardWorkspace';
import { useWorkspace } from 'features/workspace/context';
export default function DashboardRoute() {
    const { user, quickLinks } = useWorkspace();
    return _jsx(DashboardWorkspace, { user: user, links: quickLinks });
}
